import { ReactNode } from 'react';

import { DataAttributeMap, buildDataAttributes } from '@reckon-web/core';
import { useTheme } from '@reckon-web/theme';

export type StrongProps = {
  children: ReactNode;
  data?: DataAttributeMap;
  id?: string;
};

export const Strong = ({ children, data, id }: StrongProps) => {
  const { typography } = useTheme();
  return (
    <strong
      css={{ fontWeight: typography.fontWeight.bold }}
      id={id}
      {...(data ? buildDataAttributes(data) : undefined)}
    >
      {children}
    </strong>
  );
};
